import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./AddEmailModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CheckBoxItem from "../../Shared/CheckBoxItem";
import InputItem from "DreamStream/Shared/InputItem";

/**
 * Interactive component. Modal used for adding an email.
 */

export function AddEmailModal({ isOpen, onClose, onClick, checked }) {
  const [value, setValue] = useState("");
  const [sendInvite, setSendInvite] = useState(checked);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="ADD ALTERNATIVE EMAIL"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
      >
        <div className={styles.contentContainer}>
          <div className={styles.infoDiv}>
            <InputItem
              label="Alternative Email:"
              onChange={(e) => {
                setValue(e.target.value);
              }}
              placeholder="Click to type"
              value={value}
            />
          </div>

          <div className={styles.checkboxContainer}>
            <CheckBoxItem
              checked={sendInvite}
              name="Send invite email to alternate email address"
              onClick={() => {
                setSendInvite(!sendInvite);
              }}
            />
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.addBtn}
                  onClick={onClick}
                >
                  ADD EMAIL
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

AddEmailModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when add email is clicked
   */
  onClick: PropTypes.func,
  /**
   * 	True if checkbox is checked
   */
  checked: PropTypes.bool,
};
